<template>
    <div :class="['element-tree', { 'open': open }]">
        <div class="element-tree__toggle" v-if="folder.name" @click="toggle">
            <svg-icon class="svg-icon" :name="open ? 'folder-open' : 'folder'"></svg-icon>
            <span>{{ folder.name }}</span>
        </div>
        <ul class="element-tree__contents">
            <li v-for="(folder, index) in folders" :key="`folder-${index}`">
                <asset-manager-folder :folder="folder"></asset-manager-folder>
            </li>
            <asset-manager-file
                v-for="(file, index) in files"
                :key="`file-${index}`"
                class="app-vertical-navigation__submenu-item"
                :file="file">
            </asset-manager-file>
        </ul>
    </div>
</template>

<script>
import _ from 'lodash'
import AssetManagerFile from './AssetManagerFile.vue'

export default {
    components: {
    	AssetManagerFile
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        folder: {
            type: Object
        }
    },
    data () {
        return {
            open: !this.collapsed
        }
    },
    computed: {
        contents () {
            return this.folder.files || []
        },
        folders () {
            const source = _.filter(this.contents, (item) => item.files)
            return _.sortBy(source, [({ name }) => name ? name.toLowerCase() : 0])
        },
        files () {
            const source = _.filter(this.contents, (item) => !item.files)
            return _.sortBy(source, [({ name }) => name ? name.toLowerCase() : 0])
        }
    },
    methods: {
        toggle () {
            this.open = !this.open
        }
    }
}
</script>
